import { useEffect, useState } from "react";
import {
  Box, CircularProgress, Grid2 as Grid, Stack, Typography,
  Checkbox, FormControlLabel
} from "@mui/material";
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { Navigate, useLocation } from "react-router-dom";
import moment from "moment";

import TableInv from "../../components/admin/TableInv";
import PaymentModal from "../../components/modals/PaymentModal";
import { isEmpty, createData } from "../../components/common/helpers";
import { getUsers } from "../../actions/users";
import { urlImg } from "../../components/common/helpers";

import { useSelector, useDispatch } from "react-redux";

const Inversiones = () => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.auth.user);
  const usuarios = useSelector(state => state.users.users);

  const [loading, setLoading] = useState(true);
  const [history, setHistory] = useState([]);
  const [monto, setMonto] = useState("0.00");
  const [montoInv, setMontoInv] = useState("0.00");
  const [montoServ, setMontoServ] = useState("0.00");
  const [montoFacturas, setMontoFacturas] = useState("0.00");
  const [showModal, setShowModal] = useState(false);
  const [rowSelect, setRowSelect] = useState(null);
  const [cancelados, setCancelados] = useState(false);
  const [onlyPending, setOnlyPending] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("filter") === "pending") {
      setOnlyPending(true);
    }
  }, [location]);

  if (!user?.tipo_usuario) {
    return <Navigate to="/home" />
  }

  useEffect(() => {
    dispatch(getUsers());
  }, []);

  useEffect(() => {
    if (usuarios) {
      setLoading(false);
      const rows = [];
      let suma = 0;
      let sumaServicios = 0;
      let sumaInversiones = 0;
      let sumaFacturasSolicitadas = 0;
      usuarios?.map(usr => {
        usr.datos_empresas[0].inversiones.forEach(element => {
          const type = element.tipo ? element.tipo.toLowerCase() : '';
          if (type === 'servicio') {
            if (element.status === 1) {
              sumaServicios += element.monto;
            }
          } else if (type === 'inversión' || type === 'inversion') {
            sumaInversiones += element.monto;
          } else {
            // Fallback for legacy data
            if (!isEmpty(element.servicio) && element.servicio !== 'null') {
              if (element.status === 1) sumaServicios += element.monto;
            } else {
              sumaInversiones += element.monto;
            }
          }
          suma += element.monto;

          let include = false;
          if (onlyPending) {
            if (element.status === 0) include = true;
          } else {
            if (element?.status != "2" || cancelados) include = true;
          }

          if (include) {
            let filesUrl = null;
            if (Array.isArray(element.recibo)) {
              filesUrl = element.recibo.map(r => `${urlImg}/inversiones_index_dos/${usr._id}/${r}`);
            } else {
              filesUrl = `${urlImg}/inversiones_index_dos/${usr._id}/${element.recibo}`;
            }

            rows.push(
              createData(
                element.date, element.tipo, element.monto, element.status, element.metodo, element.recibo,
                element._id, usr._id, element._id, element.desc, filesUrl,
                element.servicio, element?.fechaTransaccion, element.servicioEmpresa,
                element.factura_pdf, element.factura_xml, element.fecha_facturacion, element.concepto, element.empresa
              )
            );
          }
        });
        if (usr.solicitudes_facturas) {
          usr.solicitudes_facturas.forEach(element => {
            let include = false;
            if (onlyPending) {
              if (element.status === 0) include = true;
            } else {
              include = true;
            }

            if (include) {
              sumaFacturasSolicitadas += element.monto;
              suma += element.monto;
              rows.push(
                createData(
                  element.date, 'Solicitud Factura', element.monto, element.status, 'solicitud', null,
                  element._id, usr._id, element._id, 'Solicitud de Factura', element.comprobante || null,
                  null, element.date, 'Solicitud de Factura',
                  element.factura_pdf, element.factura_xml, element.fecha_facturacion, 'Solicitud de Factura', null, element
                )
              );
            }
          });
        }
        
        const formatoMonto = suma.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        const formatoMontoInv = sumaInversiones.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        const formatoMontoServ = sumaServicios.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        const formatoMontoFacturasSol = sumaFacturasSolicitadas.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        
        setMonto(formatoMonto);
        setMontoInv(formatoMontoInv);
        setMontoServ(formatoMontoServ);
        setMontoFacturas(formatoMontoFacturasSol);
        setHistory(rows);
      })
    }
  }, [usuarios, cancelados, onlyPending]);

  if (loading) {
    return (
      <div className="loading-content">
        <CircularProgress color="inherit" />
      </div>
    );
  }

  return (
    <>
      <PaymentModal
        item={rowSelect}
        visible={showModal}
        cancelCallback={() => setShowModal(false)}
      />
      <Grid container mt={13} spacing={2}>
        <Grid className="content-form" size={12} mt={5}>
          <Typography className="titleGray" variant="h2">
            Resumen de inversión
          </Typography>
          <Typography className="subtitleMain">
            Información actualizada al {moment(Date.now()).format("LLLL")}
          </Typography>

          <Stack mt={5} spacing={5}>
            <Grid container alignItems="center" spacing={4}>
              <Grid size={{ xs: 12, md: 6 }} container spacing={3}>
                <Grid size={12}>
                  <Typography className="titleMain" variant="h6">
                    Monto Total
                  </Typography>
                </Grid>

                <Typography className="titleGray" variant="h1" sx={{ fontSize: 44 }}>
                  ${monto}
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }} container spacing={3}>
                <Grid size={12}>
                  <Typography className="titleMain" variant="h6">
                    Monto de inversiones
                  </Typography>
                </Grid>

                <Typography className="titleGray" variant="h1" sx={{ fontSize: 44 }}>
                  ${montoInv}
                </Typography>

              </Grid>
              <Grid size={{ xs: 12, md: 6 }} container spacing={3}>
                <Grid size={12}>
                  <Typography className="titleMain" variant="h6">
                    Monto de servicios
                  </Typography>
                </Grid>

                <Typography className="titleGray" variant="h1" sx={{ fontSize: 44 }}>
                  ${montoServ}
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }} container spacing={3}>
                <Grid size={12}>
                  <Typography className="titleMain" variant="h6">
                    Monto de facturas solicitadas
                  </Typography>
                </Grid>

                <Typography className="titleGray" variant="h1" sx={{ fontSize: 44 }}>
                  ${montoFacturas}
                </Typography>
              </Grid>
            </Grid>
          </Stack>

          <Stack mt={10} spacing={5}>
            <div>
              <Typography className="titleSecond" variant="h6">
                Historial
              </Typography>
              <Typography className="subtitleMain" variant="subtitle1">
                Visualiza las operaciones
              </Typography>
              <FormControlLabel
                value="bottom"
                control={<Checkbox sx={{ color: "#D8DADC" }} checked={cancelados} />}
                label="Mostrar Cancelados"
                onChange={() => setCancelados(!cancelados)}
              />
              <FormControlLabel
                value="bottom"
                control={<Checkbox sx={{ color: "#D8DADC" }} checked={onlyPending} />}
                label="Solo Pendientes"
                onChange={() => setOnlyPending(!onlyPending)}
              />
            </div>
            <Box component="section" className="table-investments">
              {
                !isEmpty(history) ? (
                  <TableInv
                    history={history}
                    onSelect={(item) => {
                      setRowSelect(item);
                      setShowModal(true);
                    }}
                    moment={moment}
                  />
                ) : (
                  <Stack className="no-data" alignItems="center" justifyContent="center" spacing={2}>
                    <SearchOffIcon color="disabled" sx={{ fontSize: 40 }} />
                    <Typography className="subtitleMain">
                      Sin datos por mostrar
                    </Typography>
                  </Stack>
                )
              }
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
}

export default Inversiones;
